import { Injectable } from "@angular/core";
import { CoreService } from "../../base/core";
import { Observable } from "rxjs";
import { ServiceRoute } from "../../base/service-route";
import { CommonHttpOption } from "../../base/common-http-option";
import { ILevelPrerequisite } from "src/app/interfaces/level-prequisite";

@Injectable({
  providedIn: "root"
})
export class LevelInfoPrerequisiteService {
  constructor(private core: CoreService) {}

  getList(
    packageId: number,
    page: number = 1,
    pageSize: number = 10
  ): Observable<any> {
    return this.core.get(
      ServiceRoute.levelInfoPrerequisite.list + packageId,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }

  getById(Id: number): Observable<any> {
    return this.core.get(
      ServiceRoute.levelInfoPrerequisite.getById + Id,
      new CommonHttpOption().headers
    );
  }

  add(data: ILevelPrerequisite): Observable<any> {
    return this.core.post(
      ServiceRoute.levelInfoPrerequisite.add,
      data,
      new CommonHttpOption().headers
    );
  }

  edit(data: ILevelPrerequisite): Observable<any> {
    return this.core.put(
      ServiceRoute.levelInfoPrerequisite.edit,
      data,
      new CommonHttpOption().headers
    );
  }

  delete(data): Observable<any> {
    return this.core.delete(
      ServiceRoute.levelInfoPrerequisite.delete,
      new CommonHttpOption().headers,
      data
    );
  }

  getLevelInfo(id: number): Observable<any> {
    return this.core.get(
      ServiceRoute.levelInfoPrerequisite.getLevelInfo + id,
      new CommonHttpOption().headers
    );
  }
}
